function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M587.333 193.138C629.247 269.97 645 392.832 585.798 450.612C580.399 455.876 553.59 482.049 516.323 482.754C450.276 484.008 429.745 403.774 370.216 402.97C323.125 402.334 319.703 454.188 251.247 478.663C242.099 481.932 125.911 521.485 56.4361 448.921C3.7096 393.849 2.08391 299.463 40.0773 249.649C76.829 201.464 132.351 218.953 167.969 164.691C199.397 116.815 170.02 79.7571 194.739 51.8627C249.742 -10.21 498.986 31.1908 587.333 193.138Z",
  fill: "#9F9998"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.8,
  d: "M152.687 278.699C225.572 261.803 278.026 219.511 269.85 184.238C261.673 148.965 195.956 134.07 123.071 150.966C50.1854 167.862 -2.2592 210.153 5.91717 245.426C14.0935 280.699 79.8075 295.597 152.687 278.699ZM145.293 168.689C198.485 156.359 246.646 168.122 252.87 194.967C259.094 221.812 221.019 253.551 167.828 265.87C114.637 278.189 66.4751 266.437 60.2514 239.595C54.0276 212.754 92.102 181.005 145.293 168.689Z",
  fill: "#DFDCDC"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.8,
  d: "M530.138 507.043C566.542 498.606 592.738 477.481 588.656 459.862C584.574 442.244 551.749 434.805 515.345 443.246C478.941 451.686 452.744 472.808 456.829 490.426C460.915 508.045 493.734 515.483 530.138 507.043ZM526.443 452.091C553.011 445.93 577.066 451.806 580.174 465.213C583.281 478.621 564.277 494.485 537.699 500.642C511.122 506.8 487.075 500.924 483.968 487.517C480.861 474.11 499.877 458.249 526.443 452.091Z",
  fill: "#9F9998"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M219.193 427.463L212.18 436.119L206.778 427.88L213.767 418.576L219.193 427.463Z",
  fill: "url(#paint0_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M228.95 387.475L211.013 418.519C211.013 418.519 214.274 427.379 220.411 429.658L261.073 387.475H228.95Z",
  fill: "url(#paint1_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M207.897 424.176C207.897 424.176 209.997 433.225 215.674 434.802C215.674 434.802 212.789 441.794 213.929 451.203C215.069 460.612 215.003 462.169 215.003 462.169C215.003 462.169 208.404 464.659 205.644 452.139C202.885 439.62 202.126 438.159 202.126 438.159L197.831 440.981L194.781 435.789C194.781 435.789 207.444 425.003 207.897 424.176Z",
  fill: "#ED6C77"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194.019 386.407L183.641 392.478L181.325 382.1L191.922 375.369L194.019 386.407Z",
  fill: "url(#paint2_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M175.959 260.786C175.959 260.786 181.658 258.579 191.37 264.76C201.082 270.942 213.776 277.013 213.776 277.013L210.575 288.051C210.575 288.051 184.745 275.69 184.745 275.357C184.745 275.024 175.959 260.786 175.959 260.786Z",
  fill: "url(#paint3_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M174.148 270.447L162.723 272.928L153.452 265.312L152.957 254.964L152.789 251.449L168.023 256.206C168.023 256.206 168.161 261.269 170.422 263.684C170.646 263.923 170.897 264.137 171.169 264.319C174.148 266.638 174.148 270.447 174.148 270.447Z",
  fill: "url(#paint4_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.422 263.684L152.957 254.964L152.789 251.449L168.023 256.206C168.023 256.206 168.161 261.269 170.422 263.684Z",
  fill: "#EF89B0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.169 235.876C171.169 235.876 175.803 246.11 183.089 245.774C183.089 245.774 177.792 252.73 171.169 251.239V235.876Z",
  fill: "url(#paint5_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.99 227.394C172.99 227.394 177.294 246.767 173.983 255.708C170.671 264.649 150.635 252.409 150.635 252.409L148.65 235.882L150.47 221.944L159.577 220.444L172.99 227.394Z",
  fill: "url(#paint6_linear)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.61 223.42C154.61 223.42 147.324 252.562 159.247 259.847C159.247 259.847 146.829 264.319 136.562 253.723C126.295 243.126 134.907 216.797 141.859 216.632C141.859 216.632 146.166 210.333 156.763 211.002C167.36 211.671 179.943 224.745 173.155 230.54C173.161 230.54 164.613 232.79 154.61 223.42Z",
  fill: "url(#paint7_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.833 260.786C168.833 260.786 171.499 267.133 170.032 268.441C166.307 271.74 153.308 262.19 153.308 262.19C153.308 262.19 143.248 264.43 140.377 273.923C137.507 283.417 152.795 318.297 183.095 331.71C213.395 345.123 216.046 344.128 216.046 344.128L211.907 285.015C211.907 285.015 196.343 278.393 188.395 270.942C180.446 263.492 177.921 258.741 168.833 260.786Z",
  fill: "url(#paint8_linear)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M216.052 349.979L189.172 374.275C189.172 374.275 189.091 384.472 194.421 389.098L220.303 378.471L216.052 349.979Z",
  fill: "url(#paint9_linear)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.863 378.789C183.863 378.789 182.537 388.726 187.672 392.478C187.672 392.478 182.096 398.438 179.667 408.375C177.237 418.312 176.577 419.856 176.577 419.856C176.577 419.856 168.962 419.856 170.947 406.167C172.933 392.478 172.714 390.714 172.714 390.714L167.315 391.914L166.208 385.51C166.208 385.51 183.089 379.451 183.863 378.789Z",
  fill: "url(#paint10_linear)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.566 276.683C200.566 276.683 204.505 271.383 204.166 265.201C203.827 259.019 205.473 248.204 205.473 248.204C205.473 248.204 210.677 248.533 210.455 256.812C210.234 265.09 213.77 272.922 211.67 278.449C209.571 283.977 203.629 284.718 203.629 284.718L200.566 276.683Z",
  fill: "url(#paint11_linear)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M141.157 271.851C137.063 275.069 137.348 286.791 147.612 298.546C157.876 310.3 178.785 325.084 183.089 325.084C187.393 325.084 195.839 312.313 199.151 302.223C202.462 292.133 205.482 285.603 205.482 285.603C205.482 285.603 203.29 274.529 200.476 274.223C200.476 274.223 185.407 292.466 181.931 303.558C181.931 303.561 151.265 263.902 141.157 271.851Z",
  fill: "url(#paint12_linear)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M420.981 79.2203H221.529C215.49 79.2203 210.593 84.1164 210.593 90.1561V521.704C210.593 527.744 215.49 532.64 221.529 532.64H420.981C427.02 532.64 431.916 527.744 431.916 521.704V90.1561C431.916 84.1164 427.02 79.2203 420.981 79.2203Z",
  fill: "#9F9998"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M409.634 89.9941H378.368C378.205 89.9937 378.043 90.0255 377.892 90.0878C377.741 90.15 377.604 90.2414 377.488 90.3567C377.372 90.4721 377.281 90.6091 377.218 90.7599C377.156 90.9108 377.123 91.0725 377.123 91.2359V100.639C377.125 101.303 376.995 101.961 376.742 102.576C376.489 103.19 376.117 103.748 375.648 104.218C375.179 104.689 374.622 105.062 374.008 105.316C373.394 105.571 372.737 105.702 372.072 105.702H270.747C270.083 105.702 269.425 105.572 268.812 105.318C268.199 105.064 267.641 104.692 267.172 104.223C266.703 103.753 266.33 103.196 266.076 102.583C265.823 101.969 265.692 101.312 265.693 100.648V91.2359C265.693 90.9065 265.562 90.5907 265.329 90.3578C265.096 90.1249 264.78 89.9941 264.451 89.9941H233.185C229.806 89.9941 226.565 91.3365 224.175 93.726C221.786 96.1155 220.444 99.3563 220.444 102.736V509.122C220.444 512.501 221.786 515.742 224.175 518.131C226.565 520.521 229.806 521.863 233.185 521.863H409.634C413.013 521.863 416.254 520.521 418.643 518.131C421.033 515.742 422.375 512.501 422.375 509.122V102.736C422.375 99.3563 421.033 96.1155 418.643 93.726C416.254 91.3365 413.013 89.9941 409.634 89.9941Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M343.167 93.2245H299.343C298.736 93.2245 298.245 93.7159 298.245 94.3222V95.513C298.245 96.1193 298.736 96.6108 299.343 96.6108H343.167C343.773 96.6108 344.265 96.1193 344.265 95.513V94.3222C344.265 93.7159 343.773 93.2245 343.167 93.2245Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M353.692 97.8526C355.312 97.8526 356.625 96.5392 356.625 94.9192C356.625 93.2991 355.312 91.9857 353.692 91.9857C352.072 91.9857 350.759 93.2991 350.759 94.9192C350.759 96.5392 352.072 97.8526 353.692 97.8526Z",
  fill: "white"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M207.837 138.321H210.593V154.019H207.837C207.507 154.019 207.19 153.888 206.957 153.655C206.723 153.421 206.592 153.105 206.592 152.775V139.577C206.591 139.413 206.622 139.25 206.684 139.097C206.745 138.945 206.837 138.806 206.953 138.689C207.068 138.572 207.206 138.48 207.358 138.416C207.51 138.353 207.672 138.321 207.837 138.321Z",
  fill: "url(#paint13_linear)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M207.837 170.642H210.593V202.964H207.837C207.507 202.964 207.19 202.832 206.957 202.599C206.723 202.366 206.592 202.049 206.592 201.719V171.887C206.592 171.557 206.723 171.24 206.957 171.007C207.19 170.773 207.507 170.642 207.837 170.642Z",
  fill: "#3C3C3B"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M207.837 214.967H210.593V247.289H207.837C207.674 247.289 207.512 247.257 207.361 247.194C207.21 247.132 207.072 247.04 206.957 246.924C206.841 246.809 206.75 246.671 206.687 246.52C206.624 246.369 206.592 246.208 206.592 246.044V216.215C206.592 216.051 206.624 215.889 206.686 215.738C206.749 215.586 206.84 215.449 206.956 215.333C207.071 215.217 207.209 215.125 207.36 215.062C207.511 215 207.673 214.967 207.837 214.967Z",
  fill: "#3C3C3B"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M434.673 236.518H431.925V183.573H434.682C435.012 183.573 435.329 183.704 435.562 183.937C435.795 184.171 435.927 184.487 435.927 184.817V235.27C435.927 235.435 435.895 235.598 435.832 235.75C435.769 235.902 435.676 236.04 435.56 236.156C435.443 236.272 435.305 236.363 435.153 236.426C435 236.488 434.837 236.519 434.673 236.518Z",
  fill: "#3C3C3B"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M378.104 486.281C378.104 486.281 374.205 495.963 361.907 498.81C349.61 501.656 344.478 502.811 343.392 505.492C342.306 508.174 362.15 511.449 367.495 511.338C373.59 507.895 375.798 507.091 375.798 507.091L374.349 512.58L380.75 514.218L388.548 489.772L378.104 486.281Z",
  fill: "#3C3C3B"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M490.645 391.71C484.163 400.447 472.753 407.406 460.39 413.15C450.651 417.679 440.318 421.455 431.332 424.757C419.784 429.005 410.459 432.475 407.468 435.756C399.199 444.832 390.348 492.823 390.348 492.823L374.949 488.219C374.949 488.219 382.861 416.293 392.483 404.811C402.105 393.33 449.073 362.361 449.073 362.361C449.073 362.361 462.102 367.046 490.645 391.71Z",
  fill: "url(#paint14_linear)"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M460.39 413.141C450.651 417.67 440.318 421.446 431.332 424.748C423.743 423.576 413.116 417.694 404.637 416.773C400.438 416.317 415.918 410.399 415.918 410.399L460.39 413.141Z",
  fill: "#1B7C96"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M357.924 463.726C357.924 463.726 351.529 473.462 337.45 473.861C323.371 474.26 317.489 474.389 315.71 477.082C313.932 479.776 334.907 487.748 340.794 488.807C348.224 486.386 350.819 485.996 350.819 485.996L348.02 491.68L354.664 494.887L368.599 469.859L357.924 463.726Z",
  fill: "#3C3C3B"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M464.451 374.214C464.451 374.214 445.528 378.267 426.94 381.281C408.353 384.295 390.417 386.182 384.499 398.825C379.484 409.541 355.747 464.212 355.747 464.212L368.491 471.902C368.491 471.902 399.043 418.954 409.226 416.113C419.409 413.273 453.527 419.239 472.117 414.014C490.708 408.789 496.017 395.6 496.017 395.6L484.532 380.345L464.451 374.214Z",
  fill: "url(#paint15_linear)"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M549.226 394.545C549.226 394.545 543.206 406.821 541.896 412.595C540.585 418.369 540.939 422.439 543.947 419.904C546.955 417.37 548.08 412.55 548.08 412.55C548.08 412.55 546.748 425.879 550.303 429.725C553.857 433.57 561.323 422.019 559.193 409.997C557.063 397.976 557.42 397.655 557.42 397.655L549.226 394.545Z",
  fill: "url(#paint16_linear)"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M405.561 305.996C405.561 305.996 404.181 297.598 401.487 294.145C398.794 290.693 394.829 291.959 396.46 295.645C398.092 299.331 398.743 300.576 392.009 299.844C385.276 299.112 387.246 295.717 381.931 296.494C376.035 297.355 372.867 303.222 379.04 308.099C385.621 313.297 397.582 308.609 402.318 311.035C405.432 307.685 405.561 305.996 405.561 305.996Z",
  fill: "url(#paint17_linear)"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M513.083 270.759C513.083 270.759 512.972 272.922 512.87 275.969C512.654 282.451 512.477 292.934 513.491 295.165C514.391 300.429 513.605 302.004 513.605 302.004L502.933 308.938L494.304 300.657L493.785 294.832C493.785 294.832 497.201 295.165 499.583 293.66C499.838 293.501 500.078 293.319 500.3 293.117C502.636 290.999 501.847 284.574 501.847 284.574L513.083 270.759Z",
  fill: "url(#paint18_linear)"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M513.083 270.759C513.083 270.759 512.972 272.922 512.87 275.969C512.801 276.413 510.543 290.714 499.583 293.666C499.838 293.507 500.078 293.325 500.3 293.123C502.636 291.005 501.848 284.58 501.848 284.58L513.083 270.759Z",
  fill: "#F28BB2"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M494.169 255.21C494.169 255.21 491.931 276.563 491.05 283.459C490.168 290.354 500.702 289.757 506.152 284.292C511.602 278.827 513.176 271.17 513.395 268.743L510.882 256.146L507.339 249.139L494.169 255.21Z",
  fill: "url(#paint19_linear)"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M513.488 295.189C513.488 295.189 509.889 304.289 503.062 303.408C496.236 302.526 495.138 294.877 495.138 294.877C495.138 294.877 489.529 292.907 485.699 296.116C484.469 309.409 482.927 325.609 482.927 325.609C482.927 325.609 479.187 349.637 441.949 365.483C441.949 365.483 475.036 390.678 492.984 388.801C506.734 379.991 529.577 337.313 532.291 321.458C535.006 305.603 532.225 298.962 532.225 298.962C532.225 298.962 527.897 294.754 513.488 295.189Z",
  fill: "url(#paint20_linear)"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M556.515 341.389C565.513 373.483 558.485 399.05 558.485 399.05C555.111 400.672 548.212 396.074 548.212 396.074C548.212 396.074 546.383 382.394 544.838 363.225C544.321 356.331 542.439 349.609 539.301 343.45C536.08 337.187 532.702 333.959 532.702 333.959C531.551 346.731 516.767 371.548 507.405 384.76C498.044 397.973 503.449 401.191 503.449 401.191C503.449 401.191 495.462 401.629 484.697 396.992C473.932 392.355 467.795 398.576 467.795 398.576C467.795 398.576 467.624 390.738 478.458 375.534C489.292 360.33 499.697 352.457 509.928 332.694C520.159 312.931 513.497 295.201 513.497 295.201C527.594 294.514 532.234 298.959 532.234 298.959C532.234 298.959 547.519 309.304 556.515 341.389Z",
  fill: "#FAB833"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M482.9 339.979C467.195 361.11 451.356 369.101 451.356 369.101L436.772 356.854C436.772 356.854 449.67 357.067 461.907 345.864C474.145 334.661 474.682 329.949 474.682 329.949C474.55 330.018 469.583 332.625 462.21 334.295C453.512 336.272 441.496 336.941 430.252 330.573C409.364 318.747 400.894 311.434 400.894 311.434C400.894 311.434 401.916 306.635 406.011 304.367C406.011 304.367 425.036 319.196 444.061 317.748C463.086 316.299 480.939 293.153 490.054 294.352C490.051 294.343 498.596 318.849 482.9 339.979Z",
  fill: "#FAB833"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M515.861 246.2C508.314 243.033 506.413 240.624 505.396 232.574C504.379 224.523 492.957 217.136 483.365 225.909C473.773 234.682 475.36 250.804 485.513 255.27C495.666 259.736 506.808 254.481 506.808 254.481L506.044 261.794C506.044 261.794 511.143 265.093 510.408 270.933C510.408 270.933 517.69 271.596 520.96 264.37C524.229 257.145 523.266 249.304 515.861 246.2Z",
  fill: "black"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M513.563 258.897L513.083 270.759C513.083 270.759 518.623 272.121 520.72 267.142C522.816 262.163 517.492 257.232 513.563 258.897Z",
  fill: "url(#paint21_linear)"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M539.301 343.45C536.08 337.187 532.702 333.96 532.702 333.96C532.702 333.96 533.602 329.883 531.949 320.204C531.94 320.204 539.088 330.783 539.301 343.45Z",
  fill: "#CD8C09"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M476.61 316.341C476.2 328.735 474.682 329.949 474.682 329.949C474.55 330.018 469.583 332.625 462.21 334.296C470.102 328.711 476.61 316.341 476.61 316.341Z",
  fill: "#CD8C09"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M583.779 4.85001H362.597C360.076 4.85001 357.659 5.85143 355.876 7.63399C354.094 9.41654 353.092 11.8342 353.092 14.3551V150.201C353.092 152.722 354.094 155.14 355.876 156.922C357.659 158.705 360.076 159.706 362.597 159.706H583.779C586.3 159.706 588.718 158.705 590.5 156.922C592.283 155.14 593.284 152.722 593.284 150.201V14.3551C593.284 11.8342 592.283 9.41654 590.5 7.63399C588.718 5.85143 586.3 4.85001 583.779 4.85001Z",
  fill: "#5BBDD7"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M407.756 25.018H380.48C379.854 24.9959 379.261 24.7317 378.825 24.281C378.39 23.8304 378.147 23.2284 378.147 22.602C378.147 21.9755 378.39 21.3736 378.825 20.9229C379.261 20.4722 379.854 20.208 380.48 20.1859H407.756C408.081 20.1745 408.404 20.2285 408.707 20.3448C409.01 20.4611 409.287 20.6372 409.52 20.8627C409.754 21.0882 409.94 21.3584 410.067 21.6572C410.193 21.956 410.259 22.2773 410.259 22.602C410.259 22.9266 410.193 23.2479 410.067 23.5467C409.94 23.8456 409.754 24.1158 409.52 24.3412C409.287 24.5667 409.01 24.7428 408.707 24.8591C408.404 24.9754 408.081 25.0294 407.756 25.018Z",
  fill: "white"
});

var _ref47 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M443.578 38.2695H380.48C379.839 38.2695 379.225 38.0151 378.772 37.5623C378.319 37.1095 378.065 36.4953 378.065 35.855C378.065 35.2146 378.319 34.6004 378.772 34.1476C379.225 33.6948 379.839 33.4404 380.48 33.4404H443.578C444.218 33.4404 444.833 33.6948 445.285 34.1476C445.738 34.6004 445.993 35.2146 445.993 35.855C445.993 36.4953 445.738 37.1095 445.285 37.5623C444.833 38.0151 444.218 38.2695 443.578 38.2695Z",
  fill: "white"
})));

var _ref48 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M387.876 108.473L417.747 77.7956L453.86 120.399L485.516 63.4285L522.672 85.3241L558.488 44.1573",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
})));

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M393.224 108.473C393.224 109.532 392.91 110.567 392.322 111.447C391.734 112.327 390.898 113.012 389.92 113.417C388.942 113.822 387.866 113.928 386.828 113.721C385.79 113.515 384.837 113.005 384.088 112.256C383.34 111.507 382.831 110.554 382.625 109.516C382.419 108.477 382.525 107.401 382.93 106.424C383.336 105.446 384.022 104.61 384.903 104.023C385.783 103.435 386.818 103.122 387.876 103.122C388.579 103.122 389.274 103.261 389.923 103.53C390.572 103.799 391.162 104.193 391.659 104.69C392.155 105.187 392.549 105.777 392.818 106.426C393.086 107.075 393.224 107.771 393.224 108.473Z",
  fill: "white"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M423.098 77.8075C423.098 78.8658 422.784 79.9003 422.196 80.7803C421.608 81.6602 420.773 82.3461 419.795 82.7511C418.817 83.1561 417.741 83.2621 416.703 83.0556C415.665 82.8491 414.712 82.3395 413.963 81.5911C413.215 80.8428 412.706 79.8894 412.499 78.8514C412.293 77.8134 412.399 76.7375 412.804 75.7597C413.209 74.782 413.894 73.9463 414.774 73.3583C415.654 72.7704 416.689 72.4565 417.747 72.4565C419.166 72.4565 420.527 73.0203 421.531 74.0238C422.534 75.0273 423.098 76.3883 423.098 77.8075Z",
  fill: "white"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M459.211 120.399C459.211 121.457 458.897 122.492 458.309 123.372C457.721 124.252 456.886 124.938 455.908 125.343C454.93 125.748 453.854 125.854 452.816 125.647C451.778 125.441 450.825 124.931 450.076 124.183C449.328 123.434 448.818 122.481 448.612 121.443C448.405 120.405 448.511 119.329 448.916 118.351C449.321 117.374 450.007 116.538 450.887 115.95C451.767 115.362 452.802 115.048 453.86 115.048C455.279 115.048 456.64 115.612 457.644 116.615C458.647 117.619 459.211 118.98 459.211 120.399Z",
  fill: "white"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M490.867 63.4283C490.867 64.4868 490.553 65.5215 489.965 66.4015C489.377 67.2815 488.541 67.9673 487.563 68.3722C486.585 68.7772 485.509 68.883 484.471 68.6762C483.433 68.4695 482.479 67.9596 481.731 67.211C480.983 66.4623 480.473 65.5086 480.267 64.4704C480.061 63.4322 480.168 62.3562 480.573 61.3785C480.978 60.4008 481.665 59.5653 482.545 58.9777C483.425 58.3901 484.46 58.0768 485.519 58.0774C486.937 58.0782 488.298 58.6423 489.3 59.6457C490.303 60.6491 490.867 62.0097 490.867 63.4283Z",
  fill: "white"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M528.092 85.2701C528.09 86.3279 527.774 87.3612 527.185 88.2396C526.595 89.118 525.759 89.802 524.781 90.2051C523.803 90.6083 522.727 90.7125 521.69 90.5047C520.653 90.2969 519.701 89.7863 518.953 89.0375C518.206 88.2887 517.698 87.3352 517.492 86.2976C517.287 85.2599 517.394 84.1847 517.799 83.2076C518.204 82.2305 518.89 81.3955 519.77 80.8081C520.649 80.2207 521.684 79.9071 522.741 79.9071C523.444 79.9071 524.14 80.0455 524.789 80.3145C525.438 80.5834 526.028 80.9775 526.525 81.4744C527.022 81.9713 527.416 82.5612 527.685 83.2104C527.954 83.8596 528.092 84.5554 528.092 85.2581",
  fill: "white"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M563.839 44.1572C563.841 45.2159 563.529 46.2514 562.942 47.1325C562.355 48.0136 561.52 48.7009 560.542 49.1073C559.565 49.5137 558.488 49.6209 557.45 49.4155C556.411 49.21 555.457 48.7011 554.708 47.9531C553.958 47.2051 553.448 46.2517 553.241 45.2135C553.034 44.1752 553.139 43.0989 553.544 42.1206C553.948 41.1423 554.634 40.3061 555.514 39.7177C556.395 39.1294 557.429 38.8153 558.488 38.8153C559.907 38.8153 561.267 39.3787 562.271 40.3815C563.274 41.3843 563.838 42.7446 563.839 44.1632",
  fill: "white"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M232.768 59.0733H129.889C128.377 59.0733 126.928 59.6737 125.859 60.7425C124.79 61.8112 124.19 63.2607 124.19 64.7722V167.652C124.19 169.163 124.79 170.613 125.859 171.681C126.928 172.75 128.377 173.351 129.889 173.351H232.768C234.279 173.351 235.729 172.75 236.798 171.681C237.866 170.613 238.467 169.163 238.467 167.652V64.7722C238.467 63.2607 237.866 61.8112 236.798 60.7425C235.729 59.6737 234.279 59.0733 232.768 59.0733Z",
  fill: "#FAB833"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M232.768 173.36H129.889C128.377 173.36 126.928 172.759 125.859 171.69C124.79 170.622 124.19 169.172 124.19 167.661V142.595H238.467V167.667C238.467 169.178 237.866 170.628 236.798 171.696C235.729 172.765 234.279 173.366 232.768 173.366",
  fill: "#F3F3F3"
});

var _ref57 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("g", {
  opacity: 0.7
}, React.createElement("path", {
  opacity: 0.7,
  d: "M150.341 132.334H141.196C140.709 132.334 140.243 132.14 139.898 131.796C139.554 131.452 139.361 130.985 139.361 130.498V106.836C139.361 106.349 139.554 105.881 139.898 105.537C140.242 105.192 140.709 104.998 141.196 104.997H150.341C150.829 104.997 151.297 105.191 151.642 105.536C151.986 105.88 152.18 106.348 152.18 106.836V130.498C152.18 130.739 152.133 130.978 152.04 131.201C151.948 131.424 151.812 131.627 151.641 131.797C151.471 131.968 151.268 132.103 151.045 132.195C150.822 132.287 150.583 132.334 150.341 132.334Z",
  fill: "white"
})));

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M174.061 132.334H164.901C164.659 132.334 164.42 132.287 164.197 132.195C163.974 132.103 163.771 131.968 163.601 131.797C163.43 131.627 163.294 131.424 163.202 131.201C163.109 130.978 163.062 130.739 163.062 130.498V85.438C163.062 85.1967 163.109 84.9577 163.202 84.7348C163.294 84.5119 163.43 84.3094 163.601 84.1389C163.771 83.9684 163.974 83.8333 164.197 83.7412C164.42 83.6492 164.659 83.602 164.901 83.6024H174.061C174.548 83.6024 175.014 83.7958 175.359 84.14C175.703 84.4843 175.896 84.9512 175.896 85.438V130.498C175.896 130.985 175.703 131.452 175.359 131.796C175.014 132.14 174.548 132.334 174.061 132.334Z",
  fill: "white"
});

var _ref59 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("g", {
  opacity: 0.7
}, React.createElement("path", {
  opacity: 0.7,
  d: "M197.756 132.334H188.611C188.124 132.334 187.657 132.14 187.313 131.796C186.969 131.452 186.775 130.985 186.775 130.498V97.7595C186.775 97.5182 186.822 97.2791 186.914 97.0561C187.006 96.833 187.141 96.6303 187.312 96.4595C187.482 96.2888 187.685 96.1533 187.908 96.0608C188.131 95.9684 188.37 95.9208 188.611 95.9208H197.756C197.997 95.9208 198.236 95.9684 198.459 96.0608C198.682 96.1533 198.885 96.2888 199.055 96.4595C199.226 96.6303 199.361 96.833 199.453 97.0561C199.545 97.2791 199.592 97.5182 199.592 97.7595V130.498C199.592 130.985 199.398 131.452 199.054 131.796C198.71 132.14 198.243 132.334 197.756 132.334Z",
  fill: "white"
})));

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M221.451 132.334H212.303C211.816 132.334 211.349 132.14 211.005 131.796C210.661 131.452 210.467 130.985 210.467 130.498V72.7955C210.467 72.3087 210.661 71.8418 211.005 71.4975C211.349 71.1533 211.816 70.9599 212.303 70.9599H221.451C221.938 70.9599 222.405 71.1533 222.749 71.4975C223.093 71.8418 223.287 72.3087 223.287 72.7955V130.498C223.287 130.985 223.093 131.452 222.749 131.796C222.405 132.14 221.938 132.334 221.451 132.334Z",
  fill: "white"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.973 154.982H140.215C139.649 154.982 139.106 154.757 138.705 154.357C138.305 153.956 138.08 153.413 138.08 152.847C138.08 152.28 138.305 151.737 138.705 151.337C139.106 150.936 139.649 150.711 140.215 150.711H166.973C167.54 150.711 168.083 150.936 168.483 151.337C168.884 151.737 169.109 152.28 169.109 152.847C169.109 153.413 168.884 153.956 168.483 154.357C168.083 154.757 167.54 154.982 166.973 154.982Z",
  fill: "#FAB833"
});

var _ref62 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M191.4 164.691H140.215C139.662 164.671 139.139 164.436 138.755 164.038C138.371 163.639 138.157 163.107 138.157 162.554C138.157 162.001 138.371 161.469 138.755 161.071C139.139 160.672 139.662 160.438 140.215 160.417H191.4C191.953 160.438 192.477 160.672 192.86 161.071C193.244 161.469 193.459 162.001 193.459 162.554C193.459 163.107 193.244 163.639 192.86 164.038C192.477 164.436 191.953 164.671 191.4 164.691Z",
  fill: "#FAB833"
})));

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M657.564 249.505H539.664C538.382 249.505 537.153 248.996 536.247 248.09C535.341 247.184 534.832 245.955 534.832 244.673V202.982C534.832 201.7 535.341 200.471 536.247 199.565C537.153 198.659 538.382 198.15 539.664 198.15H657.564C658.846 198.15 660.075 198.659 660.981 199.565C661.887 200.471 662.397 201.7 662.397 202.982V244.673C662.397 245.955 661.887 247.184 660.981 248.09C660.075 248.996 658.846 249.505 657.564 249.505Z",
  fill: "url(#paint22_linear)"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M578.287 225.978C577.882 228.738 576.698 231.326 574.875 233.437C573.051 235.548 570.664 237.096 567.992 237.898C565.32 238.701 562.475 238.726 559.79 237.969C557.105 237.212 554.691 235.706 552.831 233.626C550.972 231.546 549.744 228.98 549.291 226.227C548.839 223.474 549.18 220.65 550.276 218.084C551.371 215.518 553.175 213.318 555.477 211.741C557.778 210.165 560.481 209.277 563.269 209.181L562.513 214.265C560.734 214.501 559.056 215.227 557.667 216.364C556.278 217.5 555.233 219.001 554.65 220.698C554.067 222.396 553.969 224.222 554.366 225.972C554.764 227.722 555.641 229.327 556.9 230.606C558.159 231.884 559.75 232.787 561.493 233.212C563.237 233.637 565.064 233.567 566.771 233.011C568.477 232.454 569.994 231.433 571.152 230.062C572.31 228.691 573.063 227.024 573.326 225.249C573.476 224.245 573.465 223.223 573.293 222.223L574.004 221.698L577.627 218.998C578.414 221.235 578.64 223.631 578.287 225.975",
  fill: "#F3F6FF"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  d: "M576.503 216.536L572.429 219.559C571.741 218.157 570.721 216.944 569.459 216.024C568.196 215.105 566.729 214.506 565.183 214.28L565.918 209.319C568.114 209.641 570.209 210.459 572.042 211.711C573.876 212.963 575.4 214.616 576.5 216.545",
  fill: "#F3F6FF"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M646.248 216.545H593.548C593.295 216.555 593.042 216.514 592.805 216.424C592.567 216.334 592.351 216.197 592.168 216.021C591.985 215.845 591.84 215.634 591.74 215.401C591.641 215.168 591.589 214.917 591.589 214.663C591.589 214.409 591.641 214.158 591.74 213.925C591.84 213.691 591.985 213.48 592.168 213.305C592.351 213.129 592.567 212.992 592.805 212.902C593.042 212.812 593.295 212.771 593.548 212.781H646.248C646.734 212.8 647.194 213.007 647.531 213.358C647.868 213.709 648.056 214.176 648.056 214.663C648.056 215.149 647.868 215.617 647.531 215.968C647.194 216.319 646.734 216.526 646.248 216.545Z",
  fill: "#F3F6FF"
});

var _ref67 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M619.64 225.711H593.545C593.046 225.711 592.567 225.513 592.213 225.159C591.86 224.806 591.662 224.327 591.662 223.827C591.662 223.328 591.86 222.849 592.213 222.496C592.567 222.142 593.046 221.944 593.545 221.944H619.64C620.14 221.944 620.619 222.142 620.972 222.496C621.325 222.849 621.524 223.328 621.524 223.827C621.524 224.327 621.325 224.806 620.972 225.159C620.619 225.513 620.14 225.711 619.64 225.711Z",
  fill: "#F3F6FF"
})));

var _ref68 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M636.197 234.874H593.548C593.295 234.884 593.042 234.843 592.805 234.753C592.567 234.663 592.351 234.526 592.168 234.35C591.985 234.175 591.84 233.964 591.74 233.73C591.641 233.497 591.589 233.246 591.589 232.992C591.589 232.738 591.641 232.487 591.74 232.254C591.84 232.021 591.985 231.81 592.168 231.634C592.351 231.458 592.567 231.321 592.805 231.231C593.042 231.141 593.295 231.1 593.548 231.11H636.197C636.683 231.129 637.143 231.336 637.48 231.687C637.817 232.038 638.005 232.506 638.005 232.992C638.005 233.479 637.817 233.946 637.48 234.297C637.143 234.648 636.683 234.855 636.197 234.874Z",
  fill: "#F3F6FF"
})));

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  d: "M349.526 203.06C349.526 208.128 348.024 213.083 345.208 217.298C342.393 221.513 338.391 224.798 333.708 226.738C329.025 228.678 323.873 229.186 318.901 228.197C313.93 227.209 309.363 224.768 305.779 221.185C302.195 217.601 299.754 213.034 298.765 208.063C297.776 203.092 298.283 197.939 300.222 193.256C302.162 188.573 305.447 184.571 309.661 181.755C313.875 178.939 318.83 177.436 323.899 177.436C327.267 177.425 330.604 178.08 333.718 179.363C336.832 180.647 339.662 182.534 342.044 184.916C344.425 187.297 346.313 190.126 347.597 193.24C348.881 196.354 349.537 199.691 349.526 203.06Z",
  fill: "#B6DEFF"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M329.394 199.05C332.423 196.02 332.423 191.109 329.394 188.08C326.365 185.051 321.454 185.051 318.425 188.08C315.396 191.109 315.396 196.02 318.425 199.05C321.454 202.079 326.365 202.079 329.394 199.05Z",
  fill: "#F8FDFF"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.159 221.047C339.775 223.467 336.934 225.388 333.801 226.7C330.668 228.011 327.305 228.687 323.908 228.687C320.511 228.687 317.148 228.011 314.015 226.7C310.882 225.388 308.04 223.467 305.657 221.047C306.455 216.79 308.716 212.946 312.049 210.179C315.382 207.413 319.577 205.899 323.908 205.899C328.239 205.899 332.434 207.413 335.767 210.179C339.1 212.946 341.361 216.79 342.159 221.047Z",
  fill: "#F8FDFF"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M364.517 243.144H283.296C281.845 243.144 280.669 244.32 280.669 245.771V246.425C280.669 247.876 281.845 249.052 283.296 249.052H364.517C365.968 249.052 367.144 247.876 367.144 246.425V245.771C367.144 244.32 365.968 243.144 364.517 243.144Z",
  fill: "#9F9A98"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M349.745 259.802H298.071C296.62 259.802 295.444 260.979 295.444 262.43V263.084C295.444 264.535 296.62 265.711 298.071 265.711H349.745C351.196 265.711 352.372 264.535 352.372 263.084V262.43C352.372 260.979 351.196 259.802 349.745 259.802Z",
  fill: "#9F9A98"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M378.533 314.523H286.664C284.673 314.523 283.059 316.138 283.059 318.129V319.029C283.059 321.02 284.673 322.634 286.664 322.634H378.533C380.524 322.634 382.138 321.02 382.138 319.029V318.129C382.138 316.138 380.524 314.523 378.533 314.523Z",
  fill: "#9F9A98"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M270.958 319.759C271.619 316.955 269.883 314.146 267.079 313.484C264.276 312.822 261.466 314.559 260.805 317.362C260.143 320.166 261.879 322.975 264.683 323.637C267.487 324.299 270.296 322.562 270.958 319.759Z",
  fill: "#9F9A98"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M378.533 341.302H286.664C284.673 341.302 283.059 342.916 283.059 344.907V345.807C283.059 347.798 284.673 349.412 286.664 349.412H378.533C380.524 349.412 382.138 347.798 382.138 345.807V344.907C382.138 342.916 380.524 341.302 378.533 341.302Z",
  fill: "#9F9998"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M270.956 346.536C271.617 343.733 269.881 340.923 267.077 340.262C264.274 339.6 261.464 341.336 260.803 344.14C260.141 346.944 261.877 349.753 264.681 350.415C267.485 351.076 270.294 349.34 270.956 346.536Z",
  fill: "#9F9998"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M378.533 368.081H286.664C284.673 368.081 283.059 369.695 283.059 371.686V372.586C283.059 374.577 284.673 376.191 286.664 376.191H378.533C380.524 376.191 382.138 374.577 382.138 372.586V371.686C382.138 369.695 380.524 368.081 378.533 368.081Z",
  fill: "#DDDBDB"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M270.959 373.312C271.621 370.508 269.885 367.699 267.081 367.037C264.277 366.375 261.468 368.112 260.806 370.915C260.145 373.719 261.881 376.528 264.685 377.19C267.488 377.852 270.298 376.115 270.959 373.312Z",
  fill: "#DDDBDB"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M378.533 394.859H286.664C284.673 394.859 283.059 396.474 283.059 398.465V399.364C283.059 401.356 284.673 402.97 286.664 402.97H378.533C380.524 402.97 382.138 401.356 382.138 399.364V398.465C382.138 396.474 380.524 394.859 378.533 394.859Z",
  fill: "#F3F2F2"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M270.96 400.09C271.622 397.286 269.885 394.477 267.082 393.815C264.278 393.153 261.469 394.89 260.807 397.693C260.145 400.497 261.882 403.306 264.685 403.968C267.489 404.63 270.298 402.893 270.96 400.09Z",
  fill: "#F3F2F2"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.95778 386.713C9.05906 385.843 10.0569 383.434 9.18653 381.333C8.31615 379.231 5.90715 378.234 3.80587 379.104C1.70459 379.974 0.70675 382.383 1.57713 384.485C2.44751 386.586 4.8565 387.584 6.95778 386.713Z",
  fill: "#5BBDD7"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.1103 385.822C33.7185 384.214 33.7185 381.607 32.1103 379.998C30.502 378.39 27.8945 378.39 26.2863 379.998C24.678 381.607 24.678 384.214 26.2863 385.822C27.8945 387.431 30.502 387.431 32.1103 385.822Z",
  fill: "#5BBDD7"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.022 383.834C57.5444 381.62 56.1735 379.402 53.9599 378.88C51.7463 378.357 49.5283 379.728 49.0059 381.942C48.4834 384.155 49.8543 386.373 52.0679 386.896C54.2815 387.418 56.4995 386.047 57.022 383.834Z",
  fill: "#5BBDD7"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.4085 386.713C80.5097 385.842 81.5076 383.433 80.6372 381.332C79.7668 379.231 77.3578 378.233 75.2565 379.103C73.1553 379.974 72.1574 382.383 73.0278 384.484C73.8982 386.585 76.3072 387.583 78.4085 386.713Z",
  fill: "#5BBDD7"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.652 383.836C105.175 381.622 103.804 379.404 101.59 378.882C99.3765 378.359 97.1585 379.73 96.6361 381.944C96.1136 384.158 97.4845 386.376 99.6981 386.898C101.912 387.42 104.13 386.05 104.652 383.836Z",
  fill: "#5BBDD7"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.38032 407.658C7.65473 407.658 9.49851 405.814 9.49851 403.54C9.49851 401.265 7.65473 399.421 5.38032 399.421C3.10592 399.421 1.26215 401.265 1.26215 403.54C1.26215 405.814 3.10592 407.658 5.38032 407.658Z",
  fill: "#5BBDD7"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.1956 407.658C31.47 407.658 33.3137 405.814 33.3137 403.54C33.3137 401.265 31.47 399.421 29.1956 399.421C26.9211 399.421 25.0774 401.265 25.0774 403.54C25.0774 405.814 26.9211 407.658 29.1956 407.658Z",
  fill: "#5BBDD7"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.0139 407.658C55.2883 407.658 57.132 405.814 57.132 403.54C57.132 401.265 55.2883 399.421 53.0139 399.421C50.7395 399.421 48.8957 401.265 48.8957 403.54C48.8957 405.814 50.7395 407.658 53.0139 407.658Z",
  fill: "#5BBDD7"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.832 407.658C79.1064 407.658 80.9502 405.814 80.9502 403.54C80.9502 401.265 79.1064 399.421 76.832 399.421C74.5576 399.421 72.7138 401.265 72.7138 403.54C72.7138 405.814 74.5576 407.658 76.832 407.658Z",
  fill: "#5BBDD7"
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.647 407.658C102.922 407.658 104.766 405.814 104.766 403.54C104.766 401.265 102.922 399.421 100.647 399.421C98.3729 399.421 96.5292 401.265 96.5292 403.54C96.5292 405.814 98.3729 407.658 100.647 407.658Z",
  fill: "#5BBDD7"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.95661 427.976C9.05789 427.105 10.0557 424.696 9.18536 422.595C8.31498 420.494 5.90598 419.496 3.8047 420.366C1.70342 421.237 0.705579 423.646 1.57596 425.747C2.44634 427.848 4.85533 428.846 6.95661 427.976Z",
  fill: "#5BBDD7"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.1092 427.084C33.7174 425.476 33.7174 422.869 32.1092 421.26C30.5009 419.652 27.8935 419.652 26.2852 421.26C24.677 422.869 24.677 425.476 26.2852 427.084C27.8935 428.693 30.5009 428.693 32.1092 427.084Z",
  fill: "#5BBDD7"
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.0191 425.097C57.5416 422.883 56.1707 420.665 53.9571 420.143C51.7435 419.62 49.5255 420.991 49.003 423.205C48.4806 425.419 49.8515 427.637 52.0651 428.159C54.2787 428.681 56.4967 427.311 57.0191 425.097Z",
  fill: "#5BBDD7"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.4076 427.978C80.5088 427.107 81.5067 424.698 80.6363 422.597C79.7659 420.496 77.3569 419.498 75.2557 420.368C73.1544 421.239 72.1565 423.648 73.0269 425.749C73.8973 427.85 76.3063 428.848 78.4076 427.978Z",
  fill: "#5BBDD7"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.653 425.096C105.175 422.883 103.804 420.665 101.59 420.142C99.3769 419.62 97.1589 420.991 96.6365 423.204C96.114 425.418 97.4849 427.636 99.6985 428.158C101.912 428.681 104.13 427.31 104.653 425.096Z",
  fill: "#5BBDD7"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.38032 448.924C7.65473 448.924 9.49851 447.08 9.49851 444.805C9.49851 442.531 7.65473 440.687 5.38032 440.687C3.10592 440.687 1.26215 442.531 1.26215 444.805C1.26215 447.08 3.10592 448.924 5.38032 448.924Z",
  fill: "#5BBDD7"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.1956 448.924C31.47 448.924 33.3137 447.08 33.3137 444.805C33.3137 442.531 31.47 440.687 29.1956 440.687C26.9211 440.687 25.0774 442.531 25.0774 444.805C25.0774 447.08 26.9211 448.924 29.1956 448.924Z",
  fill: "#5BBDD7"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.0139 448.924C55.2883 448.924 57.132 447.08 57.132 444.805C57.132 442.531 55.2883 440.687 53.0139 440.687C50.7395 440.687 48.8957 442.531 48.8957 444.805C48.8957 447.08 50.7395 448.924 53.0139 448.924Z",
  fill: "#5BBDD7"
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.832 448.924C79.1064 448.924 80.9502 447.08 80.9502 444.805C80.9502 442.531 79.1064 440.687 76.832 440.687C74.5576 440.687 72.7138 442.531 72.7138 444.805C72.7138 447.08 74.5576 448.924 76.832 448.924Z",
  fill: "#5BBDD7"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.647 448.924C102.922 448.924 104.766 447.08 104.766 444.805C104.766 442.531 102.922 440.687 100.647 440.687C98.3729 440.687 96.5292 442.531 96.5292 444.805C96.5292 447.08 98.3729 448.924 100.647 448.924Z",
  fill: "#5BBDD7"
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.44577 466.12C9.81019 463.875 8.28566 461.76 6.04064 461.396C3.79561 461.031 1.68025 462.556 1.31583 464.801C0.951409 467.046 2.47594 469.161 4.72096 469.526C6.96598 469.89 9.08135 468.366 9.44577 466.12Z",
  fill: "#5BBDD7"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.2041 466.359C33.7266 464.146 32.3556 461.928 30.142 461.405C27.9284 460.883 25.7104 462.254 25.188 464.467C24.6655 466.681 26.0365 468.899 28.2501 469.421C30.4636 469.944 32.6816 468.573 33.2041 466.359Z",
  fill: "#5BBDD7"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.924 468.348C57.5323 466.74 57.5323 464.133 55.924 462.525C54.3158 460.916 51.7083 460.916 50.1 462.525C48.4918 464.133 48.4918 466.74 50.1 468.348C51.7083 469.957 54.3158 469.957 55.924 468.348Z",
  fill: "#5BBDD7"
});

var _ref105 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.9006 466.12C81.265 463.875 79.7405 461.76 77.4955 461.395C75.2505 461.031 73.1351 462.555 72.7707 464.8C72.4063 467.045 73.9308 469.161 76.1758 469.525C78.4208 469.89 80.5362 468.365 80.9006 466.12Z",
  fill: "#5BBDD7"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.559 468.35C105.167 466.742 105.167 464.134 103.559 462.526C101.951 460.918 99.3435 460.918 97.7352 462.526C96.127 464.134 96.127 466.742 97.7352 468.35C99.3435 469.958 101.951 469.958 103.559 468.35Z",
  fill: "#5BBDD7"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M596.68 301.968C598.016 301.968 599.1 300.884 599.1 299.547C599.1 298.211 598.016 297.127 596.68 297.127C595.343 297.127 594.259 298.211 594.259 299.547C594.259 300.884 595.343 301.968 596.68 301.968Z",
  fill: "#FAB833"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M610.675 301.968C612.012 301.968 613.095 300.884 613.095 299.547C613.095 298.211 612.012 297.127 610.675 297.127C609.338 297.127 608.254 298.211 608.254 299.547C608.254 300.884 609.338 301.968 610.675 301.968Z",
  fill: "#FAB833"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M624.67 301.968C626.007 301.968 627.091 300.884 627.091 299.547C627.091 298.211 626.007 297.127 624.67 297.127C623.333 297.127 622.25 298.211 622.25 299.547C622.25 300.884 623.333 301.968 624.67 301.968Z",
  fill: "#FAB833"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638.665 301.968C640.002 301.968 641.086 300.884 641.086 299.547C641.086 298.211 640.002 297.127 638.665 297.127C637.328 297.127 636.245 298.211 636.245 299.547C636.245 300.884 637.328 301.968 638.665 301.968Z",
  fill: "#FAB833"
});

var _ref111 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.66 301.968C653.997 301.968 655.081 300.884 655.081 299.547C655.081 298.211 653.997 297.127 652.66 297.127C651.324 297.127 650.24 298.211 650.24 299.547C650.24 300.884 651.324 301.968 652.66 301.968Z",
  fill: "#FAB833"
});

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M596.68 314.091C598.016 314.091 599.1 313.008 599.1 311.671C599.1 310.334 598.016 309.25 596.68 309.25C595.343 309.25 594.259 310.334 594.259 311.671C594.259 313.008 595.343 314.091 596.68 314.091Z",
  fill: "#FAB833"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  d: "M610.675 314.091C612.012 314.091 613.095 313.008 613.095 311.671C613.095 310.334 612.012 309.25 610.675 309.25C609.338 309.25 608.254 310.334 608.254 311.671C608.254 313.008 609.338 314.091 610.675 314.091Z",
  fill: "#FAB833"
});

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  d: "M624.67 314.091C626.007 314.091 627.091 313.008 627.091 311.671C627.091 310.334 626.007 309.25 624.67 309.25C623.333 309.25 622.25 310.334 622.25 311.671C622.25 313.008 623.333 314.091 624.67 314.091Z",
  fill: "#FAB833"
});

var _ref115 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638.665 314.091C640.002 314.091 641.086 313.008 641.086 311.671C641.086 310.334 640.002 309.25 638.665 309.25C637.328 309.25 636.245 310.334 636.245 311.671C636.245 313.008 637.328 314.091 638.665 314.091Z",
  fill: "#FAB833"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.66 314.091C653.997 314.091 655.081 313.008 655.081 311.671C655.081 310.334 653.997 309.25 652.66 309.25C651.324 309.25 650.24 310.334 650.24 311.671C650.24 313.008 651.324 314.091 652.66 314.091Z",
  fill: "#FAB833"
});

var _ref117 =
/*#__PURE__*/
React.createElement("path", {
  d: "M596.68 326.215C598.016 326.215 599.1 325.131 599.1 323.795C599.1 322.458 598.016 321.374 596.68 321.374C595.343 321.374 594.259 322.458 594.259 323.795C594.259 325.131 595.343 326.215 596.68 326.215Z",
  fill: "#FAB833"
});

var _ref118 =
/*#__PURE__*/
React.createElement("path", {
  d: "M610.675 326.215C612.012 326.215 613.095 325.131 613.095 323.795C613.095 322.458 612.012 321.374 610.675 321.374C609.338 321.374 608.254 322.458 608.254 323.795C608.254 325.131 609.338 326.215 610.675 326.215Z",
  fill: "#FAB833"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  d: "M624.67 326.215C626.007 326.215 627.091 325.131 627.091 323.795C627.091 322.458 626.007 321.374 624.67 321.374C623.333 321.374 622.25 322.458 622.25 323.795C622.25 325.131 623.333 326.215 624.67 326.215Z",
  fill: "#FAB833"
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638.665 326.215C640.002 326.215 641.086 325.131 641.086 323.795C641.086 322.458 640.002 321.374 638.665 321.374C637.328 321.374 636.245 322.458 636.245 323.795C636.245 325.131 637.328 326.215 638.665 326.215Z",
  fill: "#FAB833"
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.66 326.215C653.997 326.215 655.081 325.131 655.081 323.795C655.081 322.458 653.997 321.374 652.66 321.374C651.324 321.374 650.24 322.458 650.24 323.795C650.24 325.131 651.324 326.215 652.66 326.215Z",
  fill: "#FAB833"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M596.68 338.339C598.016 338.339 599.1 337.255 599.1 335.918C599.1 334.581 598.016 333.498 596.68 333.498C595.343 333.498 594.259 334.581 594.259 335.918C594.259 337.255 595.343 338.339 596.68 338.339Z",
  fill: "#FAB833"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  d: "M610.675 338.339C612.012 338.339 613.095 337.255 613.095 335.918C613.095 334.581 612.012 333.498 610.675 333.498C609.338 333.498 608.254 334.581 608.254 335.918C608.254 337.255 609.338 338.339 610.675 338.339Z",
  fill: "#FAB833"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M624.67 338.339C626.007 338.339 627.091 337.255 627.091 335.918C627.091 334.581 626.007 333.498 624.67 333.498C623.333 333.498 622.25 334.581 622.25 335.918C622.25 337.255 623.333 338.339 624.67 338.339Z",
  fill: "#FAB833"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638.665 338.339C640.002 338.339 641.086 337.255 641.086 335.918C641.086 334.581 640.002 333.498 638.665 333.498C637.328 333.498 636.245 334.581 636.245 335.918C636.245 337.255 637.328 338.339 638.665 338.339Z",
  fill: "#FAB833"
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.66 338.339C653.997 338.339 655.081 337.255 655.081 335.918C655.081 334.581 653.997 333.498 652.66 333.498C651.324 333.498 650.24 334.581 650.24 335.918C650.24 337.255 651.324 338.339 652.66 338.339Z",
  fill: "#FAB833"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  d: "M596.68 350.462C598.016 350.462 599.1 349.378 599.1 348.042C599.1 346.705 598.016 345.621 596.68 345.621C595.343 345.621 594.259 346.705 594.259 348.042C594.259 349.378 595.343 350.462 596.68 350.462Z",
  fill: "#FAB833"
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M610.675 350.462C612.012 350.462 613.095 349.378 613.095 348.042C613.095 346.705 612.012 345.621 610.675 345.621C609.338 345.621 608.254 346.705 608.254 348.042C608.254 349.378 609.338 350.462 610.675 350.462Z",
  fill: "#FAB833"
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  d: "M624.67 350.462C626.007 350.462 627.091 349.378 627.091 348.042C627.091 346.705 626.007 345.621 624.67 345.621C623.333 345.621 622.25 346.705 622.25 348.042C622.25 349.378 623.333 350.462 624.67 350.462Z",
  fill: "#FAB833"
});

var _ref130 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638.665 350.462C640.002 350.462 641.086 349.378 641.086 348.042C641.086 346.705 640.002 345.621 638.665 345.621C637.328 345.621 636.245 346.705 636.245 348.042C636.245 349.378 637.328 350.462 638.665 350.462Z",
  fill: "#FAB833"
});

var _ref131 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.66 350.462C653.997 350.462 655.081 349.378 655.081 348.042C655.081 346.705 653.997 345.621 652.66 345.621C651.324 345.621 650.24 346.705 650.24 348.042C650.24 349.378 651.324 350.462 652.66 350.462Z",
  fill: "#FAB833"
});

var _ref132 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.631 4.15717C257.779 4.15717 258.71 3.22656 258.71 2.07859C258.71 0.930617 257.779 0 256.631 0C255.483 0 254.553 0.930617 254.553 2.07859C254.553 3.22656 255.483 4.15717 256.631 4.15717Z",
  fill: "#ED6C77"
});

var _ref133 =
/*#__PURE__*/
React.createElement("path", {
  d: "M268.65 4.15717C269.798 4.15717 270.729 3.22656 270.729 2.07859C270.729 0.930617 269.798 0 268.65 0C267.502 0 266.571 0.930617 266.571 2.07859C266.571 3.22656 267.502 4.15717 268.65 4.15717Z",
  fill: "#ED6C77"
});

var _ref134 =
/*#__PURE__*/
React.createElement("path", {
  d: "M280.669 4.15717C281.816 4.15717 282.747 3.22656 282.747 2.07859C282.747 0.930617 281.816 0 280.669 0C279.521 0 278.59 0.930617 278.59 2.07859C278.59 3.22656 279.521 4.15717 280.669 4.15717Z",
  fill: "#ED6C77"
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.687 4.15717C293.835 4.15717 294.766 3.22656 294.766 2.07859C294.766 0.930617 293.835 0 292.687 0C291.539 0 290.608 0.930617 290.608 2.07859C290.608 3.22656 291.539 4.15717 292.687 4.15717Z",
  fill: "#ED6C77"
});

var _ref136 =
/*#__PURE__*/
React.createElement("path", {
  d: "M304.706 4.15717C305.854 4.15717 306.784 3.22656 306.784 2.07859C306.784 0.930617 305.854 0 304.706 0C303.558 0 302.627 0.930617 302.627 2.07859C302.627 3.22656 303.558 4.15717 304.706 4.15717Z",
  fill: "#ED6C77"
});

var _ref137 =
/*#__PURE__*/
React.createElement("path", {
  d: "M258.71 12.4895C258.71 12.9006 258.588 13.3025 258.36 13.6443C258.131 13.9861 257.806 14.2525 257.427 14.4099C257.047 14.5672 256.629 14.6084 256.226 14.5282C255.823 14.448 255.452 14.25 255.161 13.9593C254.871 13.6686 254.673 13.2982 254.593 12.895C254.512 12.4918 254.554 12.0739 254.711 11.6941C254.868 11.3143 255.135 10.9896 255.476 10.7612C255.818 10.5328 256.22 10.4109 256.631 10.4109C256.904 10.4109 257.175 10.4647 257.427 10.5691C257.679 10.6736 257.908 10.8267 258.101 11.0197C258.294 11.2127 258.447 11.4419 258.552 11.6941C258.656 11.9463 258.71 12.2165 258.71 12.4895Z",
  fill: "#ED6C77"
});

var _ref138 =
/*#__PURE__*/
React.createElement("path", {
  d: "M270.728 12.4895C270.728 12.9006 270.607 13.3025 270.378 13.6443C270.15 13.9861 269.825 14.2525 269.445 14.4099C269.066 14.5672 268.648 14.6084 268.244 14.5282C267.841 14.448 267.471 14.25 267.18 13.9593C266.889 13.6686 266.691 13.2982 266.611 12.895C266.531 12.4918 266.572 12.0739 266.73 11.6941C266.887 11.3143 267.153 10.9896 267.495 10.7612C267.837 10.5328 268.239 10.4109 268.65 10.4109C269.201 10.4109 269.73 10.6299 270.12 11.0197C270.509 11.4095 270.728 11.9382 270.728 12.4895Z",
  fill: "#ED6C77"
});

var _ref139 =
/*#__PURE__*/
React.createElement("path", {
  d: "M282.747 12.4895C282.747 12.9006 282.625 13.3025 282.397 13.6443C282.168 13.9861 281.844 14.2525 281.464 14.4099C281.084 14.5672 280.666 14.6084 280.263 14.5282C279.86 14.448 279.489 14.25 279.199 13.9593C278.908 13.6686 278.71 13.2982 278.63 12.895C278.55 12.4918 278.591 12.0739 278.748 11.6941C278.905 11.3143 279.172 10.9896 279.514 10.7612C279.856 10.5328 280.257 10.4109 280.669 10.4109C281.22 10.4109 281.748 10.6299 282.138 11.0197C282.528 11.4095 282.747 11.9382 282.747 12.4895Z",
  fill: "#ED6C77"
});

var _ref140 =
/*#__PURE__*/
React.createElement("path", {
  d: "M294.766 12.4895C294.766 12.9006 294.644 13.3025 294.415 13.6443C294.187 13.9861 293.862 14.2525 293.482 14.4099C293.103 14.5672 292.685 14.6084 292.282 14.5282C291.878 14.448 291.508 14.25 291.217 13.9593C290.927 13.6686 290.729 13.2982 290.648 12.895C290.568 12.4918 290.609 12.0739 290.767 11.6941C290.924 11.3143 291.19 10.9896 291.532 10.7612C291.874 10.5328 292.276 10.4109 292.687 10.4109C293.238 10.4109 293.767 10.6299 294.157 11.0197C294.547 11.4095 294.766 11.9382 294.766 12.4895Z",
  fill: "#ED6C77"
});

var _ref141 =
/*#__PURE__*/
React.createElement("path", {
  d: "M306.784 12.4895C306.784 12.9006 306.662 13.3025 306.434 13.6443C306.206 13.9861 305.881 14.2525 305.501 14.4099C305.121 14.5672 304.703 14.6084 304.3 14.5282C303.897 14.448 303.527 14.25 303.236 13.9593C302.945 13.6686 302.747 13.2982 302.667 12.895C302.587 12.4918 302.628 12.0739 302.785 11.6941C302.943 11.3143 303.209 10.9896 303.551 10.7612C303.893 10.5328 304.295 10.4109 304.706 10.4109C305.257 10.4109 305.786 10.6299 306.176 11.0197C306.565 11.4095 306.784 11.9382 306.784 12.4895Z",
  fill: "#ED6C77"
});

var _ref142 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.631 24.9821C257.779 24.9821 258.71 24.0515 258.71 22.9035C258.71 21.7555 257.779 20.8249 256.631 20.8249C255.483 20.8249 254.553 21.7555 254.553 22.9035C254.553 24.0515 255.483 24.9821 256.631 24.9821Z",
  fill: "#ED6C77"
});

var _ref143 =
/*#__PURE__*/
React.createElement("path", {
  d: "M268.65 24.9821C269.798 24.9821 270.729 24.0515 270.729 22.9035C270.729 21.7555 269.798 20.8249 268.65 20.8249C267.502 20.8249 266.571 21.7555 266.571 22.9035C266.571 24.0515 267.502 24.9821 268.65 24.9821Z",
  fill: "#ED6C77"
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  d: "M280.669 24.9821C281.816 24.9821 282.747 24.0515 282.747 22.9035C282.747 21.7555 281.816 20.8249 280.669 20.8249C279.521 20.8249 278.59 21.7555 278.59 22.9035C278.59 24.0515 279.521 24.9821 280.669 24.9821Z",
  fill: "#ED6C77"
});

var _ref145 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.687 24.9821C293.835 24.9821 294.766 24.0515 294.766 22.9035C294.766 21.7555 293.835 20.8249 292.687 20.8249C291.539 20.8249 290.608 21.7555 290.608 22.9035C290.608 24.0515 291.539 24.9821 292.687 24.9821Z",
  fill: "#ED6C77"
});

var _ref146 =
/*#__PURE__*/
React.createElement("path", {
  d: "M304.706 24.9821C305.854 24.9821 306.784 24.0515 306.784 22.9035C306.784 21.7555 305.854 20.8249 304.706 20.8249C303.558 20.8249 302.627 21.7555 302.627 22.9035C302.627 24.0515 303.558 24.9821 304.706 24.9821Z",
  fill: "#ED6C77"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.631 35.393C257.779 35.393 258.71 34.4624 258.71 33.3144C258.71 32.1664 257.779 31.2358 256.631 31.2358C255.483 31.2358 254.553 32.1664 254.553 33.3144C254.553 34.4624 255.483 35.393 256.631 35.393Z",
  fill: "#ED6C77"
});

var _ref148 =
/*#__PURE__*/
React.createElement("path", {
  d: "M268.65 35.393C269.798 35.393 270.729 34.4624 270.729 33.3144C270.729 32.1664 269.798 31.2358 268.65 31.2358C267.502 31.2358 266.571 32.1664 266.571 33.3144C266.571 34.4624 267.502 35.393 268.65 35.393Z",
  fill: "#ED6C77"
});

var _ref149 =
/*#__PURE__*/
React.createElement("path", {
  d: "M280.669 35.393C281.816 35.393 282.747 34.4624 282.747 33.3144C282.747 32.1664 281.816 31.2358 280.669 31.2358C279.521 31.2358 278.59 32.1664 278.59 33.3144C278.59 34.4624 279.521 35.393 280.669 35.393Z",
  fill: "#ED6C77"
});

var _ref150 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.687 35.393C293.835 35.393 294.766 34.4624 294.766 33.3144C294.766 32.1664 293.835 31.2358 292.687 31.2358C291.539 31.2358 290.608 32.1664 290.608 33.3144C290.608 34.4624 291.539 35.393 292.687 35.393Z",
  fill: "#ED6C77"
});

var _ref151 =
/*#__PURE__*/
React.createElement("path", {
  d: "M304.706 35.393C305.854 35.393 306.784 34.4624 306.784 33.3144C306.784 32.1664 305.854 31.2358 304.706 31.2358C303.558 31.2358 302.627 32.1664 302.627 33.3144C302.627 34.4624 303.558 35.393 304.706 35.393Z",
  fill: "#ED6C77"
});

var _ref152 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.631 45.8039C257.779 45.8039 258.71 44.8733 258.71 43.7253C258.71 42.5773 257.779 41.6467 256.631 41.6467C255.483 41.6467 254.553 42.5773 254.553 43.7253C254.553 44.8733 255.483 45.8039 256.631 45.8039Z",
  fill: "#ED6C77"
});

var _ref153 =
/*#__PURE__*/
React.createElement("path", {
  d: "M268.65 45.8039C269.798 45.8039 270.729 44.8733 270.729 43.7253C270.729 42.5773 269.798 41.6467 268.65 41.6467C267.502 41.6467 266.571 42.5773 266.571 43.7253C266.571 44.8733 267.502 45.8039 268.65 45.8039Z",
  fill: "#ED6C77"
});

var _ref154 =
/*#__PURE__*/
React.createElement("path", {
  d: "M280.669 45.8039C281.816 45.8039 282.747 44.8733 282.747 43.7253C282.747 42.5773 281.816 41.6467 280.669 41.6467C279.521 41.6467 278.59 42.5773 278.59 43.7253C278.59 44.8733 279.521 45.8039 280.669 45.8039Z",
  fill: "#ED6C77"
});

var _ref155 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.687 45.8039C293.835 45.8039 294.766 44.8733 294.766 43.7253C294.766 42.5773 293.835 41.6467 292.687 41.6467C291.539 41.6467 290.608 42.5773 290.608 43.7253C290.608 44.8733 291.539 45.8039 292.687 45.8039Z",
  fill: "#ED6C77"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M304.706 45.8039C305.854 45.8039 306.784 44.8733 306.784 43.7253C306.784 42.5773 305.854 41.6467 304.706 41.6467C303.558 41.6467 302.627 42.5773 302.627 43.7253C302.627 44.8733 303.558 45.8039 304.706 45.8039Z",
  fill: "#ED6C77"
});

var _ref157 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 324.931,
  cy: 202.883,
  r: 26.6947,
  fill: "#5BBDD7"
});

var _ref158 =
/*#__PURE__*/
React.createElement("path", {
  d: "M314.606 203.076L322.499 210.969L338.102 195.365",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref159 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 206.778,
  y1: 427.346,
  x2: 219.193,
  y2: 427.346,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 211.01,
  y1: 408.567,
  x2: 261.07,
  y2: 408.567,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#2F5B9B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#18386B"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 12852.1,
  y1: 26116.8,
  x2: 13389.4,
  y2: 26116.8,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 44636,
  y1: 32000.9,
  x2: 36560.8,
  y2: 31234.4,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#ED6C77"
}), React.createElement("stop", {
  offset: 0.99,
  stopColor: "#5BBDD7"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 19441.4,
  y1: 23850.5,
  x2: 20962.4,
  y2: 23850.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 177.111,
  y1: 240.915,
  x2: 175.566,
  y2: 249.415,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 1,
  stopColor: "#010101"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 26209.2,
  y1: 39607.8,
  x2: 24373,
  y2: 39658.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FAC0CB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC0CB"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 38266.8,
  y1: 47246.8,
  x2: 40432.2,
  y2: 52328.6,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 1,
  stopColor: "#491852"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 95168,
  y1: 107955,
  x2: 74526.6,
  y2: 103228,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#1B7C96"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1B7C96"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 32077.8,
  y1: 57329.9,
  x2: 35308.9,
  y2: 57329.9,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3C3C3B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#18386B"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 20509.3,
  y1: 64277.5,
  x2: 22045.9,
  y2: 64277.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EE6D78"
}), React.createElement("stop", {
  offset: 0.99,
  stopColor: "#5168F4"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 12740,
  y1: 40022.6,
  x2: 13913.6,
  y2: 40656,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 66313.4,
  y1: 60693.8,
  x2: 63532.8,
  y2: 68391.9,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#60CAE8"
}), React.createElement("stop", {
  offset: 0.99,
  stopColor: "#5168F4"
})), React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 206.592,
  y1: 146.17,
  x2: 210.593,
  y2: 146.17,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#1FC0CC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#30489E"
})), React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 236874,
  y1: 153577,
  x2: 263662,
  y2: 129771,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#5CBED8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#18386B"
})), React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 259667,
  y1: 86002.7,
  x2: 296814,
  y2: 73777.2,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#5BBDD7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#18386B"
})), React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 55274.3,
  y1: 47441.7,
  x2: 54144.9,
  y2: 47511.9,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC0CB"
})), React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 55833.9,
  y1: 6974.39,
  x2: 55961.2,
  y2: 7856.21,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 53422,
  y1: 33537.9,
  x2: 54185.1,
  y2: 33511.2,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 57555.8,
  y1: 31049.2,
  x2: 58644.7,
  y2: 30914.2,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 505.264,
  y1: 317.239,
  x2: 469.236,
  y2: 378.989,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F3FEFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C5FAFF"
})), React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 21094.4,
  y1: 9213.04,
  x2: 21272.9,
  y2: 9203.33,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F9C0CA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FC99BA"
})), React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 278219,
  y1: 50055.9,
  x2: 332472,
  y2: 50055.9,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#ED6C77"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#306DDD"
})));

var SvgHero = function SvgHero(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 663,
    height: 533,
    viewBox: "0 0 663 533",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHero, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero.7c25144f.svg";
export { ForwardRef as ReactComponent };